export enum GraphQLFetchWithAbort {
  DISABLED = 'disabled',
  // This feature flag is used to enable/disable the use of AbortController in the GraphQL fetch function.
  // This is useful for testing purposes, as it allows us to simulate a timeout error.
  ENABLED = 'enabled',
  NAME = 'graphql_fetch_with_abort',
}

export enum SearchListingServingConfig {
  DEFAULT_SEARCH = 'default_search',
  NAME = 'search_listing_serving_config',
  SEARCH_DYNAMIC_FACETS = 'search_dynamic_facets',
}

export enum HighCommissionBoosting {
  NAME = 'plp_hc_boosting',
  OFF = 'off',
  ON = 'on',
}
